import React from 'react'
import { Button } from '@/components/ui/button'
import Textarea from '../textarea'
import store from '../../state/store'

class CreateComment extends React.Component {

  constructor(props) {
    super(props)

    this.state = {
      comment_name: ''
    }
  }

  onChange = (value) => {
    this.setState({comment_name: value})
  }

  onEnter = (e) => {
    e.preventDefault()
    this.onAdd()
  }

  onCancel = () => {
    this.setState({comment_name: ''})
  }

  onAdd = () => {
    if (this.props.commentable_type == 'Sales::Enquiry') {
      store.emit('enquiry:comments:create', this.props.commentable_id, this.state.comment_name)
      this.setState({comment_name: ''})
    }
    else if (this.props.commentable_type == 'Sales::Lead') {
      store.emit('lead:comments:create', this.props.commentable_id, this.state.comment_name)
      this.setState({comment_name: ''})
    }
  }

  render() {
    const hasText = this.state.comment_name.length > 0

    return (
      <div className="flex flex-col gap-2" role="form">
        <Textarea
          rows={hasText ? '3' : '1'}
          value={this.state.comment_name}
          onChange={this.onChange}
          onEnter={this.onEnter}
          placeholder="Write a note..."
          classNames="resize-y"
        />
        {hasText && (
          <div className="flex justify-end gap-2">
            <Button size="sm" variant="ghost" type="button" onClick={this.onCancel}>
              Cancel
            </Button>
            <Button size="sm" type="button" onClick={this.onAdd}>
              Save
            </Button>
          </div>
        )}
      </div>
    )
  }
}

export default CreateComment
